import axios from '../axiosClient';
export var getRI = function (idProject, amount) { return axios.get("/ri-service/assignments/".concat(idProject, "/closer?amount=").concat(amount), {
    headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
    }
}); };
